<div class="custom-container">
  <div class="row justify-content-center">
    <div class="col-md-5 align-content-center">
      <div class="wrapper">
        <div class="card-body">
          <img src="./assets/images/logo-2025.png" class="logo" alt="Logo" />
          <h5 class="card-title text-left mb-4">Redefinindo sua senha</h5>
          <form
            class="d-flex flex-column align-items-center"
            [formGroup]="form"
          >
            <div class="w-100">
              <label for="inputPassword" class="form-label">Senha atual</label>

              <div class="password-input d-flex align-items-baseline">
                <input
                  class="form-input"
                  formControlName="oldPassword"
                  type="password"
                  id="inputPassword"
                  name="password"
                  placeholder="Digite sua senha"
                />
              </div>

              <label for="inputPassword" class="form-label mt-4"
                >Nova senha</label
              >

              <div class="password-input d-flex align-items-baseline">
                <input
                  class="form-input"
                  formControlName="newPassword"
                  type="{{ inputType[0] }}"
                  id="inputPassword"
                  name="password"
                  placeholder="Digite sua senha"
                  (keydown.enter)="onSubmit()"
                />
                @if (showPassword[0]) {
                <ng-icon
                  (click)="toggleVisibility(0)"
                  class="icon"
                  name="heroEye"
                  color="#D6D6D6"
                  size="26"
                ></ng-icon>

                } @else {
                <ng-icon
                  (click)="toggleVisibility(0)"
                  class="icon"
                  name=" heroEyeSlash"
                  color="#D6D6D6"
                  size="26"
                ></ng-icon
                >}
              </div>

              <label for="inputPassword" class="form-label mt-4"
                >Confirmação da nova senha</label
              >

              <div class="password-input d-flex align-items-baseline">
                <input
                  class="form-input"
                  #confirmation
                  formControlName="confirmPassword"
                  type="{{ inputType[1] }}"
                  id="inputPassword"
                  name="password"
                  placeholder="Digite sua senha"
                  (keydown.enter)="onSubmit()"
                />
                @if (showPassword[1]) {
                <ng-icon
                  (click)="toggleVisibility(1)"
                  class="icon"
                  name="heroEye"
                  color="#D6D6D6"
                  size="26"
                ></ng-icon>

                } @else {
                <ng-icon
                  (click)="toggleVisibility(1)"
                  class="icon"
                  name=" heroEyeSlash"
                  color="#D6D6D6"
                  size="26"
                ></ng-icon
                >}
              </div>

              <button
                class="btn btn-no-auth mt-4"
                (click)="onSubmit()"
                [disabled]="form.invalid"
              >
                Finalizar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-6 slider">
      <app-slider></app-slider>
    </div>
  </div>
</div>
